import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, Clock, ArrowLeft } from 'lucide-react';

const Impressum = () => {
  return (
    <section className="section-padding bg-gradient-to-b from-luxury-pearl via-white to-luxury-pearl min-h-screen">
      <div className="container-custom max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          {/* Back Button */}
          <motion.a
            href="/"
            whileHover={{ x: -5 }}
            className="inline-flex items-center text-luxury-gold hover:text-luxury-charcoal transition-colors mb-8 font-semibold"
          >
            <ArrowLeft className="mr-2" size={20} />
            Zurück zur Startseite
          </motion.a>

          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-5xl md:text-6xl font-display font-bold text-luxury-charcoal mb-4">
              Impressum
            </h1>
            <div className="w-24 h-1 bg-luxury-gold mx-auto" />
          </div>

          {/* Content */}
          <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12 space-y-8">
            
            {/* Angaben gemäß § 5 TMG */}
            <div>
              <h2 className="text-2xl font-display font-bold text-luxury-charcoal mb-4">
                Angaben gemäß § 5 TMG
              </h2>
              <div className="space-y-2 text-luxury-slate">
                <p className="font-semibold text-lg">Nerma Lukic</p>
                <p>Wodental 4</p>
                <p>45529 Hattingen</p>
              </div>
            </div>

            {/* Kontakt */}
            <div>
              <h2 className="text-2xl font-display font-bold text-luxury-charcoal mb-4">
                Kontakt
              </h2>
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <Phone className="text-luxury-gold" size={20} />
                  <a href="tel:+49232456650" className="text-luxury-slate hover:text-luxury-gold transition-colors">
                    +49232456650
                  </a>
                </div>
                <div className="flex items-center space-x-3">
                  <Mail className="text-luxury-gold" size={20} />
                  <a href="mailto:info@lacasa-hotel.de" className="text-luxury-slate hover:text-luxury-gold transition-colors">
                    info@lacasa-hotel.de
                  </a>
                </div>
              </div>
            </div>

            {/* Rezeption */}
            <div className="bg-luxury-gold/10 rounded-2xl p-6 border border-luxury-gold/30">
              <h3 className="text-xl font-display font-bold text-luxury-charcoal mb-4 flex items-center">
                <Clock className="mr-2 text-luxury-gold" size={24} />
                Öffnungszeiten
              </h3>
              <div className="space-y-2 text-luxury-slate">
                <div>
                  <p className="font-semibold">Restaurant:</p>
                  <p>Freitag – Dienstag: 17:00 – 22:00 Uhr</p>
                  <p className="text-sm">(Küche nimmt Bestellungen bis 21:00 an)</p>
                  <p className="text-sm text-red-600 font-semibold">Mittwoch und Donnerstag: Geschlossen</p>
                </div>
                <div className="pt-2 border-t border-luxury-gold/30 mt-3">
                  <p className="font-semibold">Hotel Check-in:</p>
                  <p>Freitag – Dienstag: 15:00 – 18:00 Uhr</p>
                  <p>Mittwoch und Donnerstag: 17:00 – 18:00 Uhr</p>
                  <p className="text-sm italic mt-2">(Für Ankunft außerhalb dieser Zeit, bitte kontaktieren Sie uns telefonisch)</p>
                </div>
              </div>
            </div>

            {/* Haftung für Inhalte */}
            <div>
              <h2 className="text-2xl font-display font-bold text-luxury-charcoal mb-4">
                Haftung für Inhalte
              </h2>
              <p className="text-luxury-slate leading-relaxed mb-4">
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
              </p>
              <p className="text-luxury-slate leading-relaxed">
                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
              </p>
            </div>

            {/* Haftung für Links */}
            <div>
              <h2 className="text-2xl font-display font-bold text-luxury-charcoal mb-4">
                Haftung für Links
              </h2>
              <p className="text-luxury-slate leading-relaxed mb-4">
                Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
              </p>
              <p className="text-luxury-slate leading-relaxed">
                Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
              </p>
            </div>

            {/* Urheberrecht */}
            <div>
              <h2 className="text-2xl font-display font-bold text-luxury-charcoal mb-4">
                Urheberrecht
              </h2>
              <p className="text-luxury-slate leading-relaxed mb-4">
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
              </p>
              <p className="text-luxury-slate leading-relaxed">
                Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
              </p>
            </div>

          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Impressum;
